<template>
	<el-dialog :title="dialogType+'资源'" :visible.sync="outerVisible" :before-close="handleClose">
		<el-form :model="resourceModels" label-position="top" label-width="120px">
			<el-form-item label="资源名称">
				<el-input v-model="resourceModels.name" style="width: 100%;"></el-input>
			</el-form-item>
			<el-form-item label="所属产品">
				<el-select placeholder="请选择" v-model="resourceModels.productID" disabled="disabled">
					<el-option label="全部产品" value="">
					</el-option>
					<el-option v-for="item in productList" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="资源分类">
				<el-select placeholder="请选择" v-model="resourceModels.resourceTypeID">
					<el-option label="全部分类" value="">
					</el-option>
					<el-option v-for="item in getResourceTypeList(resourceModels.productID)" :label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="设置任务描述">
				<el-input v-model="introduce.renWuMiaoShu" type="textarea" rows="2"></el-input>
			</el-form-item>
			<el-form-item label="设置知识目标">
				<el-input v-model="introduce.zhiShiMuBiao" type="textarea" rows="2"></el-input>
			</el-form-item>
			<el-form-item label="设置技能目标">
				<el-input v-model="introduce.jiNengMuBiao" type="textarea" rows="2"></el-input>
			</el-form-item>
			<el-form-item label="设置素养目标">
				<el-input v-model="introduce.suYangMuBiao" type="textarea" rows="2"></el-input>
			</el-form-item>
			<el-form-item label="设置任务目标">
				<el-input v-model="introduce.renWuMuBiao" type="textarea" rows="2"></el-input>
			</el-form-item>
			<el-form-item label="设置任务分析">
				<el-input v-model="introduce.renWuFenXi" type="textarea" rows="2"></el-input>
			</el-form-item>
			<el-form-item label="实施流程-上传文件(单文件)">
				<el-row>
					<el-col :span="18">
						<iframe v-if="introduce.shiShiLiuCheng" :src="$config.fileurl+introduce.shiShiLiuCheng"
							style="width: 95%;height:300px;opacity:1;z-index:1;"></iframe>
					</el-col>
					<el-col :span="6">
						<el-upload class="avatar-uploader" :action="$http.defaults.baseURL+'api/ToolApi/UpFiles'"
							:data="{path:'OldAge/'+resourceModels.id}"
							:headers="{'Authorization': 'Bearer ' + $http.token}" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<i class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="课件学习-上传文件(多文件)">
				<el-upload class="upload-demo" :action="$config.baseURL+'api/ToolApi/UpFiles'"
					:data="{path:'OldAge/'+resourceModels.id}" :headers="{'Authorization': 'Bearer ' + $http.token}"
					:on-success="handleChange" :on-remove="removeFile" :file-list="fileList"
					:before-upload="beforeAvatarUploads">
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf/mp4文件，且不超过300Mb</div>
				</el-upload>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="save()">保存</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				resourceModels: {
					id: this.$guid.guid(),
					name: '',
					productID: '8e451222-bdb9-905f-7f07-0b2e4e5bb1a5',
					resourceTypeID: '',
					introduce: '',
					extension: '',
					fileSize: 0,
					fileType: 'json',
					fileAddress: '',
					buildUser: ''
				},
				introduce: {
					// id: '',
					// modelName: '',
					renWuMiaoShu: '',
					zhiShiMuBiao: '',
					jiNengMuBiao: '',
					suYangMuBiao: '',
					renWuMuBiao: '',
					renWuFenXi: '',
					shiShiLiuCheng: '',
					fileList: []
				},
				fileList: [],
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		props: {
			dialogType: {
				type: String
			},
			outerVisible: {
				type: Boolean
			},
			productList: {
				type: Array
			},
			resourceTypeList: {
				type: Array
			},
			obj: {
				type: Object
			}
		},
		watch: {
			obj(val) {
				this.resourceModels = JSON.parse(JSON.stringify(val))
				this.introduce = JSON.parse(this.resourceModels.introduce)
				this.fileList = this.introduce.fileList
			}
		},
		methods: {
			getResourceTypeList(val) {
				return this.resourceTypeList.filter(item => item.productID == val)
			},
			//上传文件
			handleAvatarSuccess(res, file) {
				if (JSON.stringify(file).indexOf('身份认证失败,未获取授权') > -1) {
					this.$message({
						message: "身份认证失败，刷新页面重试",
						type: 'info'
					})
					window.location.reload()
				}
				this.introduce.shiShiLiuCheng = file.response.data
			},
			beforeAvatarUpload(file) {
				const isType = file.type === 'application/pdf'
				const isLt10M = file.size / 1024 / 1024 < 50

				if (!isType) {
					this.$message({
						message: '上传文件只能是 pdf 格式!',
						type: 'error'
					});
				}
				if (!isLt10M) {
					this.$message({
						message: '上传文件大小不能超过 10MB!',
						type: 'error'
					});
				}
				return isType && isLt10M;
			},
			//多文件
			handleChange(file, fileList) {
				if (file.code === 3001) {
					this.$message({
						message: "身份认证失败，刷新页面重试",
						type: 'info'
					})
					window.location.reload()
				}
				this.introduce.fileList.push({
					name: fileList.name,
					filrurl: file.data
				});
			},
			beforeAvatarUploads(file) {
				console.log(file)
				const isType = file.type == 'application/pdf' || file.type == 'image/jpeg' || file.type == "image/png" ||
					file.type == 'video/mp4'
				const isLt10M = file.size / 1024 / 1024 < 300

				if (!isType) {
					this.$message({
						message: '上传文件只能是jpg/png/pdf/mp4 格式!',
						type: 'error'
					});
				}
				if (!isLt10M) {
					this.$message({
						message: '上传文件大小不能超过 300MB!',
						type: 'error'
					});
				}
				return isType && isLt10M;
			},
			removeFile(file, fileList) {
				this.introduce.fileList.splice(this.introduce.fileList.indexOf(file), 1)
			},
			handleClose() {
				this.$emit('before-close')
			},
			save() {

				if (this.resourceModels.name == '' || this.resourceModels.name == null) {
					this.$message({
						message: "资源名称不能为空",
						type: 'info'
					})
				} else if (this.resourceModels.productID == '' || this.resourceModels.productID == null) {
					this.$message({
						message: "所属产品不能为空",
						type: 'info'
					})
				} else if (this.resourceModels.resourceTypeID == '' || this.resourceModels.resourceTypeID == null) {
					this.$message({
						message: "所属模块不能为空",
						type: 'info'
					})
				} else {
					// this.resourceModels.buildUser = this.getUserInfo.id
					// this.introduce.id = this.resourceModels.resourceTypeID

					if (this.introduce.renWuMiaoShu == '' || this.introduce.zhiShiMuBiao == '' || this.introduce
						.jiNengMuBiao == '' || this.introduce.suYangMuBiao == '' || this.introduce.renWuMuBiao == '' ||
						this.renWuFenXi == '') {
						this.$message({
							message: "输入框有空值，请完善",
							type: 'info'
						})
					} else if (this.introduce.shiShiLiuCheng == '') {
						this.$message({
							message: "请上传实施流程pdf文件",
							type: 'info'
						})
					} else if (this.introduce.fileList.length == 0) {
						this.$message({
							message: "请上传课件资源文件",
							type: 'info'
						})
					} else {
						this.resourceModels.introduce = JSON.stringify(this.introduce)

						let url = 'api/productResource/EditProduct_Resource'
						if (this.dialogType == '添加') {
							url = 'api/productResource/SaveProduct_Resource'
						}

						//保存 产品资源 信息
						this.$http.post(url, this.resourceModels).then(res => {
							if (res.data.code == '1') {
								this.$message({
									message: "资源记录保存成功",
									type: 'success'
								})
								this.handleClose()
							} else {
								this.$message({
									message: "资源记录保存失败",
									type: 'error'
								})
							}
						})
					}
				}
			}
		}

	}
</script>

<style>
</style>
